<div class="image-cropper-dialog">
  <div class="div image-cropper-header pl-5p">
    <p class="mb-1 font-600 font-14 flex-between-center">
      <span>Edit Image</span>
      <span class="close-dialog">
        <i class="fal fa-times" (click)="closeModal()"></i>
      </span>
    </p>
    <p class="mb-1 font-12 font-gray-45">Drag the corners to crop the photo</p>
  </div>

  <div class="div image-cropper-body">
    <image-cropper [hidden]="!image" [imageChangedEvent]="imageChangedEvent" [imageFile]="image"
      [maintainAspectRatio]="true" format="png" (imageCropped)="imageCropped($event)"></image-cropper>
  </div>

  <div class="div image-cropper-footer text-right">
    <div class="ui-g-12 part-footer">
      <button class="btn btn-border pointer btn-submit mr-1" (click)="closeModal()">Cancel</button>
      <button class="btn btn-primary btn-submit" (click)="saveImage()">Save</button>
    </div>
  </div>
</div>
